module.exports = __webpack_public_path__ + "media/flags/mu-13bb0788.svg";